export default {
  'reportGroups.title': 'Configure Report Group',
  'reportGroups.form.powerBIServerConfigurationId': 'Power BI Server Configuration',
  'reportGroups.form.powerBIReportGroupId': 'PowerBI Report Group Id',
  'reportGroups.permissionsFiltersLogicalOperator': 'Permissions Logical Operator',
};
